import React, { useEffect, useState } from 'react';
import api from '../../api/axios';
import { ChevronDown } from 'lucide-react';

const Layout4Form = ({ data, onChange, errors }) => {
  const { video, brand, titles = [], products = [], subTitle } = data;

  const [campaigns, setCampaigns] = useState([]);

  const handleChange = (section, field, value) => {
    // let cleanedValue = (value || '').replace(/%/g, "");

    let cleanedValue = value;

    // Only clean string values
    if (typeof value === "string") {
      cleanedValue = (value || '').replace(/%/g, "");
    }


    if (field === 'url' || field === 'logoUrl' || field === 'imageUrl' || field === 'qrCodeUrl') {
      cleanedValue = value
    }
    onChange('layout4', section, field, cleanedValue);
  };

  const getCampaigns = async () => {
    try {
      const response = await api.get('campaign/list');
      if (response && response.data && response.data.data) {
        setCampaigns(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCampaigns();
  }, []);


  return (
    <div className="layout4-form">
      {/* Canvas Settings */}
      <div className="form-section">

        <div className="form-group">
          <label>Campaign Name</label>
          <div className='relative'>
            <select
              value={data.camp_name}
              onChange={(e) => handleChange(null, 'camp_name', e.target.value)}
              className={`appearance-none ${errors?.camp_name ? "has-error" : ""} `}
            >
              <option value="">Select Campaign</option>
              {campaigns.map((camp) => (
                <option key={camp.camp_id} value={camp.camp_name}>
                  {camp.camp_name}
                </option>
              ))}
            </select>
            <ChevronDown size={18} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-600 pointer-events-none" />
          </div>
          {errors?.camp_name && (
            <p className="text-red-500 text-sm mt-1">
              {errors.camp_name}
            </p>
          )}
        </div>

        <div className="form-group">
          <label>Brand Name</label>

          <input
            type="text"
            value={data.brand_name || ''}
            onChange={(e) => handleChange(null, 'brand_name', e.target.value)}
            className={errors?.brand_name ? "has-error" : ""}
          />
          {errors?.brand_name && (
            <p className="text-red-500 text-sm mt-1">
              {errors.brand_name}
            </p>
          )}
        </div>

        <div className="form-group">
          <label>Domain</label>
          <input
            type="text"
            value={data.domain || ''}
            onChange={(e) => handleChange(null, 'domain', e.target.value)}
            className={errors?.domain ? "has-error" : ""}
          />
          {errors?.domain && (
            <p className="text-red-500 text-sm mt-1">
              {errors.domain}
            </p>
          )}
        </div>

        <div className="form-group">
          <label>Creative Name</label>
          <input
            type="text"
            value={data.creative_name || ''}
            onChange={(e) => handleChange(null, 'creative_name', e.target.value)}
            className={errors?.creative_name ? "has-error" : ""}
          />
          {errors?.creative_name && (
            <p className="text-red-500 text-sm mt-1">
              {errors.creative_name}
            </p>
          )}
        </div>

        <div className="form-group hidden">
          <label>Background Type</label>
          <div className='relative'>
            <select
              value={data.canvas?.backgroundType || 'solid'}
              onChange={(e) => handleChange('canvas', 'backgroundType', e.target.value)}
              className='appearance-none'
            >
              <option value="solid">Solid</option>
              <option value="gradient">Gradient</option>
            </select>
            <ChevronDown size={18} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-600 pointer-events-none" />
          </div>
        </div>

        {data.canvas?.backgroundType === 'gradient' && (
          <>
            <div className="form-group">
              <label>Gradient Color 1</label>
              <div className="color-input-group">
                <input
                  type="color"
                  value={data.canvas?.gradientColor1 || data.canvas?.backgroundColor || '#e0e0e0'}
                  onChange={(e) => handleChange('canvas', 'gradientColor1', e.target.value)}
                />
                <input
                  type="text"
                  value={data.canvas?.gradientColor1 || data.canvas?.backgroundColor || '#e0e0e0'}
                  onChange={(e) => handleChange('canvas', 'gradientColor1', e.target.value)}
                  placeholder="#e0e0e0"
                  className="color-text-input"
                />
              </div>
            </div>
            <div className="form-group">
              <label>Gradient Color 2</label>
              <div className="color-input-group">
                <input
                  type="color"
                  value={data.canvas?.gradientColor2 || '#ffffff'}
                  onChange={(e) => handleChange('canvas', 'gradientColor2', e.target.value)}
                />
                <input
                  type="text"
                  value={data.canvas?.gradientColor2 || '#ffffff'}
                  onChange={(e) => handleChange('canvas', 'gradientColor2', e.target.value)}
                  placeholder="#ffffff"
                  className="color-text-input"
                />
              </div>
            </div>
            <div className="form-group hidden">
              <label>Gradient Angle (deg)</label>
              <input
                type="number"
                min="0"
                max="360"
                value={data.canvas?.gradientAngle ?? 135}
                onChange={(e) => handleChange('canvas', 'gradientAngle', parseInt(e.target.value, 10) || 0)}
              />
            </div>
          </>
        )}
        <div className="form-group hidden">
          <label>Padding (px)</label>
          <input
            type="text"
            value={data.canvas?.padding || 20}
            onChange={(e) => handleChange('canvas', 'padding', e.target.value || 0)}
          />
        </div>
      </div>

      {/* Video Section */}
      <div className="form-section">
        <h3>Canvas and video settings</h3>
        {(data.canvas?.backgroundType || 'solid') === 'solid' && (
          <>
            <div className="form-group">
              <label>Left Background Color</label>
              <div className="color-input-group">
                <input
                  type="color"
                  value={data.canvas?.sideBackgroundColor || '#d66700'}
                  onChange={(e) => handleChange('canvas', 'sideBackgroundColor', e.target.value)} />
                <input
                  type="text"
                  value={data.canvas?.sideBackgroundColor || '#d66700'}
                  onChange={(e) => handleChange('canvas', 'sideBackgroundColor', e.target.value)}
                  placeholder="#d66700"
                  className="color-text-input" />
              </div>
            </div>

            <div className="form-group">
              <label>Bottom Background Color</label>
              <div className="color-input-group">
                <input
                  type="color"
                  value={data.canvas?.bottomBackgroundColor || '#ffffff'}
                  onChange={(e) => handleChange('canvas', 'bottomBackgroundColor', e.target.value)} />
                <input
                  type="text"
                  value={data.canvas?.bottomBackgroundColor || '#ffffff'}
                  onChange={(e) => handleChange('canvas', 'bottomBackgroundColor', e.target.value)}
                  placeholder="#ffffff"
                  className="color-text-input" />
              </div>
            </div>
          </>
        )}

        <div className="form-group">
          <label>Video URL (1920 x 1080)</label>
          <input
            type="text"
            value={video.url}
            onChange={(e) => handleChange('video', 'url', e.target.value)}
            placeholder="Enter video URL"
          />
          <span className='text-xs text-blue-500'>Aspect ratio: (1920 x 1080)</span>
        </div>



      </div>

      <div className="form-section">
        <h3>Titles</h3>

        {[0, 1, 2].map((index) => (
          <div key={index} className="form-group">
            <label>Title {index + 1}</label>

            <input
              type="text"
              value={titles[index] || ""}
              placeholder="Enter title"
              maxLength={38}
              onChange={(e) => {
                const updatedTitles = [...titles];
                updatedTitles[index] = e.target.value;
                handleChange(null, "titles", updatedTitles);
              }}
            />
          </div>
        ))}

        <div className="form-group">
          <label>Subtitle</label>

          <input
            type="text"
            value={subTitle || ""}
            maxLength={62}
            placeholder="Crafted for those who value every second"
            onChange={(e) =>
              handleChange(null, "subTitle", e.target.value)
            }
          />
        </div>

        <div className="form-group">
          <label>Title Text Color</label>
          <div className="color-input-group">
            <input
              type="color"
              value={data.canvas?.titleTextColor || '#121212'}
              onChange={(e) => handleChange('canvas', 'titleTextColor', e.target.value)} />
            <input
              type="text"
              value={data.canvas?.titleTextColor || '#121212'}
              onChange={(e) => handleChange('canvas', 'titleTextColor', e.target.value)}
              placeholder="#121212"
              className="color-text-input" />
          </div>
        </div>
        <div className="form-group">
          <label>Subtitle Text Color</label>
          <div className="color-input-group">
            <input
              type="color"
              value={data.canvas?.subTitleTextColor || '#ffffff'}
              onChange={(e) => handleChange('canvas', 'subTitleTextColor', e.target.value)} />
            <input
              type="text"
              value={data.canvas?.subTitleTextColor || '#ffffff'}
              onChange={(e) => handleChange('canvas', 'subTitleTextColor', e.target.value)}
              placeholder="#ffffff"
              className="color-text-input" />
          </div>
        </div>
      </div>



      {/* Products */}
      <div className="form-section">
        <h3>Products</h3>

        {[0, 1, 2].map((index) => (
          <div key={index} className="form-group">
            <label>Product {index + 1} URL</label>

            <input
              type="text"
              value={products[index] || ""}
              placeholder="Enter product image URL"
              onChange={(e) => {
                const updatedProducts = [...products];
                updatedProducts[index] = e.target.value;

                handleChange(null, "products", updatedProducts);
              }}
            />
            <p className="text-blue-600 text-xs">
              Image must be at least 1080 × 1080 pixels.
            </p>
          </div>
        ))}
      </div>


      {/* Brand Section */}
      <div className="form-section">
        <h3>Brand</h3>
        <div className="form-group">
          <label>Logo URL</label>
          <input
            type="text"
            value={brand.logoUrl}
            onChange={(e) => handleChange('brand', 'logoUrl', e.target.value)}
            placeholder="Enter logo URL"
          />
          <p className="text-blue-600 text-xs">
            Image must be at least 250 × 250 pixels.
          </p>
        </div>
        <div className="form-group">
          <label>QR Code URL</label>
          <input
            type="text"
            value={brand.qrCodeUrl}
            onChange={(e) => handleChange('brand', 'qrCodeUrl', e.target.value)}
            placeholder="Enter QR code URL"
          />
        </div>
      </div>
    </div>
  );
};

export default Layout4Form;

